import { Injectable, OnDestroy } from "@angular/core";
import { VesselGroupsService } from "@app/services/vessel-groups/vessel-groups.service";
import { Observable, ReplaySubject, Subscription } from "rxjs";
import { ApiService } from "@app/services/api/api.service";

@Injectable({
  providedIn: "root",
})
export class CiiService implements OnDestroy {
  private cii;
  private ciiSubject: ReplaySubject<any>;

  private ciiReportSubject: ReplaySubject<any>;
  private ciiTracksSubject: ReplaySubject<any>;

  private subscriptions: Subscription[] = [];

  private ciiTracksVesselSub?: Subscription;
  private ciiTracksRequestSub?: Subscription;
  private ciiRequestSub?: Subscription;

  private selectedVessel: any | null = null;

  constructor(
    private apiService: ApiService,
    private vesselGroupsService: VesselGroupsService
  ) {}

  public getCiiObservable(): Observable<any> {
    if (!this.ciiSubject) {
      this.ciiSubject = new ReplaySubject<any>(1);

      this.subscriptions.push(
        this.vesselGroupsService.getSelectedVesselObservable().subscribe({
          next: (selectedVessel) => {
            this.setSelectedVessel(selectedVessel);
          },
        })
      );
    }
    return this.ciiSubject;
  }

  public getCiiReportObservable(): Observable<any> {
    if (!this.ciiReportSubject) {
      this.ciiReportSubject = new ReplaySubject<any>(1);
      this.getCiiObservable().subscribe({
        next: () => this.startCiiReportUpdate(),
      });
    }
    return this.ciiReportSubject;
  }

  public getCiiTracksObservable(year: number): Observable<any> {
    if (!this.ciiTracksSubject) {
      this.ciiTracksSubject = new ReplaySubject<any>(1);
    }

    this.ciiTracksVesselSub?.unsubscribe();
    this.ciiTracksVesselSub = this.getCiiObservable().subscribe({
      next: () => {
        this.startCiiTracksUpdate(year);
      },
    });

    return this.ciiTracksSubject;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) subscription.unsubscribe();
    this.ciiTracksVesselSub?.unsubscribe();
    this.ciiTracksRequestSub?.unsubscribe();
    this.ciiRequestSub?.unsubscribe();
  }

  private setSelectedVessel(selectedVessel): void {
    if (selectedVessel && selectedVessel !== this.selectedVessel) {
      this.selectedVessel = selectedVessel;
      this.startCiiUpdate();
    }
  }

  private startCiiUpdate(): void {
    this.cii = undefined;
    if (this.ciiSubject) this.ciiSubject.next(this.cii);

    const hrefCii = this.apiService.resolveLink(this.selectedVessel._links["fo:cii"].href);
    if (!hrefCii) return;

    this.ciiRequestSub?.unsubscribe();
    this.ciiRequestSub = this.apiService.get(hrefCii).subscribe({
      next: (cii) => {
        this.cii = cii;
        this.ciiSubject.next(cii);
      },
      error: () => this.ciiSubject.next(undefined),
    });
  }

  private startCiiReportUpdate(): void {
    this.ciiReportSubject.next(this.cii);
  }

  private startCiiTracksUpdate(year: number): void {
    this.ciiTracksSubject?.next(undefined);
    if (this.cii === undefined) return;

    const href = this.apiService.resolveLink(this.cii._links["fo:history"].href, {"year": [year]});
    if (!href) {
      this.ciiTracksSubject.next(undefined);
      return;
    }

    this.ciiTracksRequestSub?.unsubscribe();
    this.ciiTracksRequestSub = this.apiService.get(href).subscribe({
      next: (ciiTracks) => this.ciiTracksSubject.next(ciiTracks),
      error: () => this.ciiTracksSubject.next(undefined),
    });
  }
}
